/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import styled from 'styled-components';
import Link from '@com/core/common/components/Link';
import { breakpoints } from '@com/core/common/styles/baseStyles';
import { useTranslation } from '@com/core/common/translations/i18n';
import { THit } from '@com/core/common/types/catalog';
import ProductBox from '../../listing/ProductBoxPLPDesktop';
import Subscription from '../../detail/SubscribeOrSchedule/Subscription';

type TProps = {
    initialNum?: number;
    products: THit[];
    productUrl: string;
};

const ProductList = ({ initialNum, productUrl, products }: TProps): JSX.Element => {
    const { t } = useTranslation('common');
    const [numProductsToShow, setNumProductsToShow] = useState(initialNum || 8);
    const [showSubscriptionModal, setShowSubscriptionModal] = useState<boolean>(false);
    const [productSkuConfig, setProductSkuConfig] = useState<string>('');

    const showMore = () => {
        setNumProductsToShow(numProductsToShow + initialNum);
    };

    return (
        <div className="siteWidthContainer">
            <ProductBoxGrid>
                {products.slice(0, numProductsToShow).map(product => (
                    <>
                        <ProductBoxWrapper key={product.offer_code}>
                            <ProductBox
                                isSubscriptionModal={showSubscriptionModal}
                                showSubscriptionModal={(show, prodSkuconfig) => {
                                    setShowSubscriptionModal(!showSubscriptionModal);
                                    setProductSkuConfig(prodSkuconfig);
                                }}
                                titleWidth={160}
                                eventLocation="page_static"
                                product={product}
                            />
                        </ProductBoxWrapper>
                        {product.sku_config === productSkuConfig && (
                            <Subscription
                                closeModal={() => {
                                    setProductSkuConfig('');
                                    setShowSubscriptionModal(false);
                                }}
                                product={product}
                                skuConfig={product?.sku_config}
                                offerCode={product?.offer_code}
                                showSubscriptionBox={false}
                                subscriptionModalView="subscribe"
                            />
                        )}
                    </>
                ))}
            </ProductBoxGrid>
            <CtaContainer>
                {numProductsToShow >= products.length || numProductsToShow >= initialNum * 3 ? (
                    <Link href={productUrl}>{t('view-all')}</Link>
                ) : (
                    <button type="button" onClick={showMore}>
                        {t('view-more')}
                    </button>
                )}
            </CtaContainer>
        </div>
    );
};

const ProductBoxGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -24px 0 0 -16px;

    @media ${breakpoints.minDesktop} {
        margin: -32px 0 0 -24px;
    }

    @media ${breakpoints.minDesktopLG} {
        margin: -40px 0 0 -32px;
    }
`;

const ProductBoxWrapper = styled.div`
    flex: 0 0 33.33333%;
    padding: 24px 0 0 16px;

    @media ${breakpoints.minDesktop} {
        flex: 0 0 25%;
        padding: 32px 0 0 24px;
    }

    @media ${breakpoints.minDesktopLG} {
        flex: 0 0 20%;
        padding: 40px 0 0 32px;
    }
`;

const CtaContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 12px;

    button,
    a {
        border: 1px solid;
        border-radius: ${({ theme }): string => theme.metrics.borderRadius};
        font-weight: bold;
        padding: 8px 32px;
        font-size: 0.875rem;
        text-transform: uppercase;

        &:hover {
            color: ${({ theme }): string => theme.colors.brandPrimary};
        }
    }
`;

export default ProductList;
